
import { Button } from "@/components/Button";

const EducationCTA = () => {
  return (
    <section className="py-16 md:py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-blue-900/30 opacity-30"></div>
      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Transform Your Legal Practice?</h2>
          <p className="text-lg md:text-xl text-white/80 mb-8 max-w-3xl mx-auto">
            Schedule a consultation to discuss how our AI education programs can be tailored to meet your firm's specific needs.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Button variant="primary" size="lg">Schedule Consultation</Button>
            <Button variant="outline" size="lg">Learn More</Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationCTA;
